import getConfig from 'next/config';
const { publicRuntimeConfig } = getConfig();

const ITR_UTM_REF = 'itr_2023_organic_landing_page_2';
const startFilingLink = `${publicRuntimeConfig.CLEARTAX_DOMAIN}/filing?utm_ref=${ITR_UTM_REF}`;
export const startFilingLinkViewPlans = `${publicRuntimeConfig.CLEARTAX_DOMAIN}/filing/?showplan=1&utm_ref=${ITR_UTM_REF}`;
export const cryptoIntegrationLink = `${publicRuntimeConfig.SSO_ENDPOINT}?product=crypto&utm_ref=crypto_itr_2_integration_page&return_path=L2NyeXB0by10YXgtZmlsaW5nL2Jyb2tlcnMv`;

const heroSection = {
  title: 'File ITR for capital gains in minutes ',
  lists: [
    'Capital gains from Stocks, Mutual Funds, bonds and more',
    'Futures & Options (F&O), Crypto, Derivatives, Commodity traders',
    'P&L Reports, Currency Conversion, Set-Off Losses. All Automated.',
  ],
  button: [
    {
      text: 'Start filing',
      url: startFilingLink,
    },
    {
      text: 'View plans',
    },
  ],
};

const whyChooseSection = {
  title: 'Features That Simplify Your Capital Gains Filing',
  lists: [
    {
      title: 'Auto application of carry forward of losses',
      desc: 'Offset your trading losses automatically',
    },
    {
      title: ' Auto application of 1.25 LTCG deductions ',
      desc: 'Ensure maximum savings with all deductions',
    },
    {
      title: 'Automatic ITR Form Selection',
      desc: 'No hassle over ITR forms, type. We handle it all',
    },
  ],
  buttons: [
    {
      text: 'Start FIling',
      url: startFilingLink,
    },
  ],
};
export const ExchangeList = [
  {
    id: '1',
    icon: 'https://assets1.cleartax-cdn.com/finfo/wg-utils/retool/718342aa-8b15-49d5-9d1a-45d1806e5c1e.png',
    name: 'Upstox',
  },
  {
    id: '2',
    icon: 'https://assets1.cleartax-cdn.com/finfo/wg-utils/retool/db2e54bb-de91-464e-8814-060c807fc7c3.png',
    name: 'Kite',
  },
  {
    id: '3',
    icon: 'https://assets1.cleartax-cdn.com/finfo/wg-utils/retool/3bc8bfe5-ea83-404c-b41e-8f5ea8d633e8.png',
    name: 'Groww',
  },
  {
    id: '4',
    icon: 'https://assets1.cleartax-cdn.com/finfo/wg-utils/retool/4b73f019-0e78-4e20-a1c8-4b0798130b54.png',
    name: 'ICICI Direct',
  },
  {
    id: '5',
    icon: 'https://assets1.cleartax-cdn.com/finfo/wg-utils/retool/e8ce47b3-1f4c-48c8-aece-129ab4c098ff.png',
    name: 'Paytm Money',
  },
  {
    id: '6',
    icon: 'https://assets1.cleartax-cdn.com/finfo/wg-utils/retool/bb34b676-c260-4564-8789-353fa5cb6237.png',
    name: 'SBI Caps',
  },
  {
    id: '7',
    icon: 'https://assets1.cleartax-cdn.com/finfo/wg-utils/retool/1a4f9afc-2d8e-4289-9190-04eed9f7a244.png',
    name: 'Kotak',
  },
  {
    id: '8',
    icon: 'https://assets1.cleartax-cdn.com/finfo/wg-utils/retool/a965c566-85b4-4d76-b10a-687be311c652.png',
    name: 'Axis Securities',
  },
  {
    id: '9',
    icon: 'https://assets1.cleartax-cdn.com/finfo/wg-utils/retool/734b28d5-91cf-4d68-8382-82209468c896.png',
    name: 'Reliance Securities',
  },
  {
    id: '10',
    icon: 'https://assets1.cleartax-cdn.com/finfo/wg-utils/retool/d37ab44c-70e2-493b-8bbc-eed9dcc53534.png',
    name: 'Zerodha',
  },
  {
    id: '11',
    icon: 'https://assets1.cleartax-cdn.com/finfo/wg-utils/retool/5937fd37-48df-404b-be2e-ed89f99e3a12.png',
    name: 'HDFC Securities',
  },
];

export const ExchangeList2 = [
  {
    id: '1',
    icon: 'https://assets1.cleartax-cdn.com/cleartax/images/1675108712_wazirx_logo.png',
    name: 'WazirX',
  },
  {
    id: '2',
    icon: 'https://assets1.cleartax-cdn.com/cleartax/images/1675109419_coindcx_logo.png',
    name: 'CoinDCX',
  },
  {
    id: '3',
    icon: 'https://assets1.cleartax-cdn.com/taxengine-crypto/images/1682491670_coinswitch.svg',
    name: 'CoinSwitch',
  },
  {
    id: '4',
    icon: 'https://assets1.cleartax-cdn.com/cleartax/images/1675109376_binance_logo.png',
    name: 'Binance',
  },
  {
    id: '5',
    icon: 'https://assets1.cleartax-cdn.com/cleartax/images/1675109827_coinbase_logo.png',
    name: 'Coinbase',
  },
  {
    id: '6',
    icon: 'https://assets1.cleartax-cdn.com/cleartax/images/1675109384_bitbns_logo.png',
    name: 'BitBNS',
  },
  {
    id: '7',
    icon: 'https://assets1.cleartax-cdn.com/cleartax/images/1675108721_zebpay__logo.png',
    name: 'Zebpay',
  },
  {
    id: '8',
    icon: 'https://assets1.cleartax-cdn.com/cleartax/images/1675108642_metamask_logo.png',
    name: 'Metamask',
  },
  {
    id: '9',
    icon: 'https://assets1.cleartax-cdn.com/cleartax/images/1675109568_etherium_logo.png',
    name: 'Etherium',
  },
  {
    id: '10',
    icon: 'https://assets1.cleartax-cdn.com/cleartax/images/1675108612_kucoin_logo.png',
    name: 'KuCoin',
  },
  {
    id: '11',
    icon: 'https://assets1.cleartax-cdn.com/cleartax/images/1675108657_solana_logo.png',
    name: 'Solana',
  },
  {
    id: '10',
    icon: 'https://assets1.cleartax-cdn.com/cleartax/images/1675108612_kucoin_logo.png',
    name: 'KuCoin',
  },
  {
    id: '11',
    icon: 'https://assets1.cleartax-cdn.com/cleartax/images/1675108657_solana_logo.png',
    name: 'Solana',
  },
];

export const itrData = {
  heroSection,
  isVariant: false,
  whyChooseSection,
};

export const GuidesAndLinksDataITR2 = {
  heading: 'Guides and useful links to help you Efile taxes',
  cards: [
    {
      label: 'Types of capital gains income',
      description: `Learn about capital gains, its classification as short-term and long-term, and its taxation. Know about the various deductions available to save taxes on capital gains.`,
      link: 'https://cleartax.in/s/capital-gains-income',
    },
    {
      label: 'Types of capital gains income',
      description: `Learn about capital gains, its classification as short-term and long-term, and its taxation. Know about the various deductions available to save taxes on capital gains.`,
      link: 'https://cleartax.in/s/capital-gains-income',
    },
    {
      label: 'Set off & carry forward capital losses',
      description: `Understand how to treat capital losses and adjust them against gains to reduce taxable income.`,
      link: 'https://cleartax.in/s/set-off-carry-forward-capital-losses',
    },
    {
      label: 'Tax implications on mutual funds',
      description: `Before investing in mutual funds, understand how your returns will be taxed. Also, get tax deductions in certain cases.`,
      link: 'https://cleartax.in/s/different-mutual-funds-taxed',
    },
    {
      label: 'Tax Filing for F&O Income',
      description: `Income from F&O trading is treated as Business Income. Taxpayers can opt for presumptive taxation if they are below the threshold limit.`,
      link: 'https://cleartax.in/s/tax-filing-security-traders',
    },
    {
      label: 'What Is ITR-3?',
      description: `Taxpayers with business income exceeding Rs. 50 lakh need to file Form ITR-3. ITR-3 is applicable for traders reporting F&O income. It is important to understand the applicability of ITR-3.`,
      link: 'https://cleartax.in/s/itr3',
    },
    {
      label: 'What is ITR-4?',
      description: `Taxpayers with business income and opting for presumptive taxation need to file ITR-4. ITR-4 is applicable for F&O income under presumptive income not exceeding Rs. 50 lakh.`,
      link: 'https://cleartax.in/s/itr4',
    },
    {
      label: 'Guide to crypto taxes in India 2025',
      description: `Everything you need to know about how cryptocurrencies in India are taxed. Know if crypto is a currency or an asset.`,
      link: 'https://cleartax.in/s/itr-filing-for-traders',
    },
  ],
};

export const ITR_2_FAQs = [
  {
    header:
      'I buy and sell shares. Do I fall into the category of trader or investor?',
    content: (
      <>
        <p>
          Good Question. If you buy shares and hold them for a certain period
          and then sell them, then it is an investment. Income from intraday
          trading and F&O trading will always be considered as business income.
        </p>
      </>
    ),
  },
  {
    header:
      'Do I need to show my income from trading on my income tax return? If yes, how should I do it?',
    content: (
      <p>
        Yes, you are required to show your income or losses from your trading on
        your income tax return. You need to show the profit or loss from trading
        in the profit and loss account in ITR-3 or ITR-4. The benefit of showing
        the loss from trading is that you can set it off from other incomes
        (except salary) and save tax. You can also carry forward the excess loss
        to the next assessment year and set it off against the business income
        of that assessment year.
      </p>
    ),
  },
  {
    header: 'How do I calculate my turnover from F&O trading?',
    content: (
      <p>
        If you do delivery-based trading, then the total of sales values is your
        turnover. In case of non-delivery-based trading, the total of positive
        and negative transactions is considered to be the turnover. If you are
        trading in options, then the turnover will be the total of positive and
        negative transactions, converted into a positive figure, including the
        premium received on the sale of options.
      </p>
    ),
  },
  {
    header:
      'Can I opt for presumptive taxation (section 44AD) for my trading income?',
    content: (
      <p>
        You can opt for presumptive taxation under Section 44AD only if your
        trading income is treated as business income and your turnover does not
        exceed Rs. 3 crore. So, if your trading is non-speculative business
        income and meets the turnover criteria, you can opt for presumptive
        taxation under 44AD.
      </p>
    ),
  },
  {
    header: 'When do traders have to file income tax returns?',
    content: (
      <p>
        Like salaried persons, traders opting for presumptive tax will now need
        to file their income tax returns by 15th September, 2025. If a tax audit
        applies to them, then the last date to file ITR as well as the tax audit
        report is September 30, 2025, and the due date to file ITR is 31st
        October 2025.
      </p>
    ),
  },
  {
    header: `I am an NRI for this year as per the income tax laws and trade in shares. Can I opt for presumptive taxation?`,
    content: (
      <p>
        No, presumptive taxation is available for Indian residents only. NRI
        cannot opt for it.
      </p>
    ),
  },
  {
    header: 'When do I need to maintain accounting records?',
    content: (
      <p>
        Traders eligible under presumptive tax are not required to maintain any
        books of account. However, they are mandated to keep books of account if
        the income disclosed is less than 6% of gross receipts and the total
        income exceeds Rs. 250,000, OR the turnover exceeds Rs. 3 crores. In
        this case, professionals will also be required to conduct their audit.
      </p>
    ),
  },
  {
    header:
      'I have a loss from trading and other business income. Can I set off the loss from trading against my normal business income?',
    content: (
      <p>
        If the trading is not intraday, then it is non-speculative business, and
        the loss of speculative business can be set off against both
        non-speculative and speculative business profits. If it is intraday
        trading, then it is a speculative business, and the loss from such
        business can be set off against speculative business profit only. Loss
        from Non-speculative business can be set off against any income except
        salary.
      </p>
    ),
  },
];
